import { InterventionDistributionDef } from "../type/intervention-distribution-def";

export class InterventionDistributionAdapter {
  static toOutputDTO(res: any): InterventionDistributionDef {
    return {
      node_distribution: res.node_distribution.map((item: any) => ({
        level: item.level,
        is_median: item.is_median,
        proba: item.proba,
      })),
    };
  }
}
